export const IS_DESKTOP = window.innerWidth >= 1024;
export const IS_MOBILE = window.innerWidth <= 1024;
